import prodCodeMap from '@/assets/maps/prodCodeMap.json'

const getPolicyProductType = (policy) => {
  const motorProductIds = ['0100', '0110']
  const motorcycleVehicleUsage = '1003'
  const hasCorrectVehicleUsage = (possiblePolicy, vehicleUsage) => {
    return possiblePolicy.vehicleUsage ? possiblePolicy.vehicleUsage === vehicleUsage : true
  }
  const foundPolicy = prodCodeMap.find(p => {
    return p.code === policy.prodCode && hasCorrectVehicleUsage(p, policy.vehicleUsage)
  })
  if (motorProductIds.includes(foundPolicy?.code) && policy.vehicleUsage !== motorcycleVehicleUsage) {
    return 'car'
  }
  return foundPolicy?.type
}

export default getPolicyProductType
